/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var NProgress = require('nprogress');
var _get = require('lodash.get');
var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetLicenseContactTypes = require('../../new-license/services/GetLicenseContactTypes');
var GetLicenseIdentifiers = require('../services/GetLicenseIdentifiers');
var GetLicenseContactTypesByLicenseType = require('../../new-license/services/GetLicenseContactTypesByLicenseType');
var GetLicenseDashboard = require('../services/GetLicenseDashboard');
var GetLicenseContactsAndOfficersByEntity = require('../../common/services/GetLicenseContactsAndOfficersByEntity');
var NonDepEditLicenseContactsView = require('../views/NonDepEditLicenseContactsView');

module.exports = function(entityId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(
    GetLicenseContactTypes(),
    GetLicenseDashboard(licenseId),
    GetLicenseIdentifiers(licenseId),
    GetLicenseContactsAndOfficersByEntity(entityId)
  )
    .done(function(licenseContactTypes, licenseDashboard, licenseIdentifiers, existingContacts) {
      GetLicenseContactTypesByLicenseType(_get(licenseDashboard, 'licenseTypeId'))
        .done(function(requiredLicenseContactTypes) {
          var licenseContacts = [];
          NavUtils.navigate('nondep/entity/' + entityId + '/license/' + licenseId + '/edit-license-contacts');
          _.each(licenseDashboard.licenseContacts, function(contacts) {
            _.each(contacts.contacts, function(contact) {
              var contactAddress = contact.address;
              licenseContacts.push(_.extend(contact, contactAddress, { licenseContactTypeId: contact.typeId }));
            });
          });
          Scaffold.content.show(
            new NonDepEditLicenseContactsView({
              viewMode: 'int',
              model: new Backbone.Model({
                entityId: entityId,
                licenseId: licenseId,
                entityName: licenseDashboard.entityName,
                licenseIdentifiers: licenseIdentifiers,
                licenseContacts: licenseContacts,
                existingContacts: existingContacts,
                licenseContactTypes: licenseContactTypes,
                requiredLicenseContactTypes: requiredLicenseContactTypes
              })
            })
          );
          NProgress.done();
        })
        .fail(function(err) {
          NProgress.done();
        });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
